import { firebaseConfig } from './config';
export const firebase = require("firebase/app");
// require("firebase/auth");
// require("firebase/database");
require("firebase/storage");


export const firebaseApp = firebase.initializeApp(firebaseConfig);
export const firebaseStorage = firebase.storage();
// export const firebaseAuth = firebaseApp.auth();
// export const firebaseDb = firebaseApp.database();
// export const GoogleAuthProvider = firebase.auth.GoogleAuthProvider;

// export { FirebaseList } from './firebase-list';
// export { FirebaseObject } from './firebase-object';



// WEBPACK FOOTER //
// ./src/core/firebase/index.js